import React, { Component } from 'react'
import RaisedButton from 'material-ui/RaisedButton'
import Snackbar from 'material-ui/Snackbar'

import Rate from './types/Rate'
import Text from './types/Text'
import MultiText from './types/MultiText'
import Msg from '../../components/Msg'
import {
  sendFeedback,
  getLocalFeedback,
  clearLocalFeedback,
} from './feedbackService'

const TYPES = {
  rate: Rate,
  text: Text,
  multiline: MultiText,
}

const MSG = {
  sent: <Msg id="addons.Feedback.sent" />,
  sentOk: <Msg id="addons.Feedback.sentOk" />,
  sentError: <Msg id="addons.Feedback.sentError" />,
}

class Feedback extends Component {
  constructor(props) {
    super(props)
    this.state = {
      answers: getLocalFeedback(props.subjectId) || {},
      submitting: false,
      snackMsg: null,
    }
  }

  render() {
    const { definition, submitButtonLabel } = this.props
    if (!definition) {
      console.log('No feedback definition provided -> noop')
      return null
    }
    const { title, questions } = definition
    const { answers, submitting, snackMsg } = this.state
    return (
      <div>
        {title && <h3>{title}</h3>}
        {questions.map(q => {
          const Component = TYPES[q.type]
          if (!Component) {
            console.warn('Wrong feedback question type', q)
            return null
          }
          return (
            <Component
              key={q.id}
              {...q}
              value={answers[q.id]}
              onChange={val => this.onChange(q.id, val)}
            />
          )
        })}
        <div style={{ textAlign: 'right' }}>
          <RaisedButton
            label={submitButtonLabel || MSG.sent}
            primary={true}
            disabled={submitting}
            onClick={this.send}
          />
        </div>
        <Snackbar
          open={!!snackMsg}
          message={snackMsg || ''}
          autoHideDuration={4000}
          onRequestClose={this.handleRequestClose}
        />
      </div>
    )
  }

  onChange = (qid, ev) => {
    const value = getEventValue(ev)
    const { answers } = this.state
    answers[qid] = value
    this.setState({ answers })
  }

  send = () => {
    const { cfg, subjectId } = this.props
    const { answers } = this.state
    console.log('sendFeedback', answers)
    this.setState({ submitting: true })
    sendFeedback(cfg, subjectId, answers)
      .then(this.sentOk)
      .catch(this.sentError)
  }

  sentOk = () => {
    const { remember, subjectId } = this.props
    this.setState({
      submitting: false,
      snackMsg: MSG.sentOk,
      answers: remember ? this.state.answers : {},
    })
    if (!remember) {
      clearLocalFeedback(subjectId)
    }
  }

  sentError = () => {
    this.setState({ submitting: false, snackMsg: MSG.sentError })
  }

  handleRequestClose = () => {
    this.setState({
      snackMsg: null,
    })
  }
}

function getEventValue(ev) {
  if (ev.currentTarget) {
    // react form onChange event
    return ev.currentTarget.value
  }
  // fallback - onChange sometimes pass value directly
  return ev
}

Feedback.defaultProps = {
  subjectId: 'general',
  remember: true,
}

export default Feedback



// WEBPACK FOOTER //
// ./src/addons/feedback/Feedback.js